// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getPrioridades as listPrioridadesAPI,
    // getPrioridad as getPrioridadAPI,
    // addPrioridad as addPrioridadAPI,
    // updatePrioridad as updatePrioridadAPI,
    // deletePrioridad as deletePrioridadAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { prioridadesApiResponseError, prioridadesApiResponseSuccess } from './actions';
import { PrioridadesActionTypes } from './constants';

// const api = new APICore();

// /**
//  * Get contacto
//  * @param {*} payload - username and password
//  */
// function* getPrioridad({ payload: { id } }) {
//     try {
//         const response = yield call(getPrioridadAPI, id );
//         const prioridadItem = response.data.data;
//         yield put(prioridadesApiResponseSuccess(PrioridadesActionTypes.GET_PRIORIDAD, prioridadItem));
//     } catch (error) {
//         yield put(prioridadesApiResponseError(PrioridadesActionTypes.GET_PRIORIDAD, error));
//     }
// }

// function* addPrioridad({payload:prioridad}){
//     try{
//         const response = yield call(addPrioridadAPI,{...prioridad})
//         const prioridadItem = response.data
//         yield put(prioridadesApiResponseSuccess(PrioridadesActionTypes.ADD_PRIORIDAD,prioridadItem))
//     } catch(error){
//         yield put(prioridadesApiResponseError(PrioridadesActionTypes.ADD_PRIORIDAD,error))
//     }
// }

// function* updatePrioridad({payload:prioridad}){
//     try{
//         const response = yield call(updatePrioridadAPI,{...prioridad})
//         const prioridadItem = response.data.data
//         yield put(prioridadesApiResponseSuccess(PrioridadesActionTypes.UPDATE_PRIORIDAD,prioridadItem))
//     }catch(error){
//         yield put(prioridadesApiResponseError(PrioridadesActionTypes.UPDATE_PRIORIDAD,error))
//     }
// }
// function* deletePrioridad({payload:{id}}){
//     try{
//         const response = yield call(deletePrioridadAPI,id)
//         const prioridadItem = response.data.id
//         yield put(prioridadesApiResponseSuccess(PrioridadesActionTypes.DELETE_PRIORIDAD,prioridadItem))
//     }catch(error){
//         yield put(prioridadesApiResponseError(PrioridadesActionTypes.DELETE_PRIORIDAD,error))
//     }
// }

/**
 * List contactos
 */
function* listPrioridades() {
    try {
        const response = yield call(listPrioridadesAPI);
        const listaPrioridades = response.data.data;
        yield put(prioridadesApiResponseSuccess(PrioridadesActionTypes.LIST_PRIORIDADES, listaPrioridades));
    } catch (error) {
        yield put(prioridadesApiResponseError(PrioridadesActionTypes.LIST_PRIORIDADES, error));
    }
}


// export function* watchGetPrioridad(): any {
//     yield takeEvery(PrioridadesActionTypes.GET_PRIORIDAD, getPrioridad);
// }

export function* watchListPrioridades(): any {
    yield takeEvery(PrioridadesActionTypes.LIST_PRIORIDADES, listPrioridades);
}

// export function* watchAddPrioridad():any{
//     yield takeEvery(PrioridadesActionTypes.ADD_PRIORIDAD,addPrioridad)
// }
// export function* watchUpdatePrioridad():any{
//     yield takeEvery(PrioridadesActionTypes.UPDATE_PRIORIDAD,updatePrioridad)
// }
// export function* watchDeletePrioridad():any{
//     yield takeEvery(PrioridadesActionTypes.DELETE_PRIORIDAD,deletePrioridad)
// }


function* prioridadesSaga(): any {
    yield all([
        // fork(watchGetPrioridad),
        fork(watchListPrioridades),
        // fork(watchAddPrioridad),
        // fork(watchUpdatePrioridad),
        // fork(watchDeletePrioridad),
    ]);
}

export default prioridadesSaga;
